import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { definedSearchParams } from '@/lib/search-params';

import { MealPatternsScreen } from './MealPatternsScreen';
import type { MealPatternsSearch } from './meal-patterns-search';

const route = getRouteApi('/meal-patterns');

export function MealPatternsRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onSearchChange = useCallback(
    (next: MealPatternsSearch) => {
      void navigate({
        replace: true,
        // Absent rather than undefined: a `?slot=` with no value in the URL is
        // noise a shared link should not carry.
        search: () => definedSearchParams(next),
      });
    },
    [navigate],
  );

  return <MealPatternsScreen search={search} onSearchChange={onSearchChange} />;
}
